import type { ISeverity } from '@/types/severity'
import type { IFinding, IFindingStatus } from '@/types/appsec/finding'
import { useState } from 'react'

export default function useFilteredFindings<T extends IFinding>(findings: T[]) {
  const [filteredFindings, setFilteredFindings] = useState<T[]>(findings)
  function filterFindings(filterCriteria: {
    severity: ISeverity | null
    status: IFindingStatus | null
    repository: string | null
  }) {
    setFilteredFindings(
      findings
        .filter((f) => f.severity === filterCriteria.severity || filterCriteria.severity === null)
        .filter((f) => f.status === filterCriteria.status || filterCriteria.status === null)
        .filter((f) => f.repository === filterCriteria.repository || filterCriteria.repository === null),
    )
  }
  return {
    filteredFindings,
    filterFindings,
    setFilteredFindings,
  }
}
